import styled, { css, } from 'styled-components';
import { propsToForward } from '../../tools/utils';
import { SelectCircleContainer } from '../SelectCircle';
const baseCardStyles = css `
  ${({ $inlineCardWidth, $inlineCardAlignment, }) => {
    return css `
      justify-content: ${$inlineCardAlignment || 'flex-start'};
      flex-direction: column;
      width: ${$inlineCardWidth};
      flex: 1;
    `;
}}
`;
const inlineCardStyles = css `
  text-align: center;
  height: 100%;
  ${baseCardStyles}
`;
const inlineExpandableCardStyles = css `
  ${({ $inlineCardHeight, $isExpanded, }) => {
    const isFitContent = !$inlineCardHeight || $isExpanded;
    return css `
      text-align: left;
      height: ${isFitContent ? 'fit-content' : '100%'};
      ${baseCardStyles}
    `;
}}
`;
const stackedStyles = css `
  justify-content: flex-start;
  flex-direction: row;
  text-align: left;
  min-height: 56px;
`;
export const cardContainerStyles = css `
  border: ${({ $isSelected, $showError, theme: { colors } }) => {
    if ($showError) {
        return `1px solid ${colors.error}`;
    }
    if ($isSelected) {
        return `1px solid ${colors.bluesuedeshoes}`;
    }
    return `1px solid ${colors['periwinkle-300']}`;
}};

  ${({ $isSelected, $hasDescription, $align, theme: { space, colors }, }) => `
        display: flex;
        position: relative;
        flex-direction: row;
        flex-shrink: 0;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        padding: ${space.md};
        border-radius: 4px;
        cursor: pointer;
        box-sizing: border-box;
        background: ${colors.white};
        
        box-shadow: ${$isSelected
    ? '0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16)'
    : 'none'};
        outline: none;

        &:focus {
          border: 2px solid ${colors.bluesuedeshoes};
          padding: calc(${space.md} - 1px);
          ${SelectCircleContainer} {
            top: ${!$hasDescription && $align === 'stacked'
    ? 'unset'
    : `calc(${space.xs} - 1px)`};
            right: calc(${space.xs} - 1px);
          }
        }
  `}

  ${({ $align, $isExpandableCard, }) => {
    if ($align === 'inline' && $isExpandableCard) {
        return inlineExpandableCardStyles;
    }
    if ($align === 'inline') {
        return inlineCardStyles;
    }
    return stackedStyles;
}}
`;
export const CardContainer = styled.button.withConfig({
    shouldForwardProp: propsToForward,
}) `
  ${cardContainerStyles}
`;
//# sourceMappingURL=CardContainer.js.map